import { gql } from 'apollo-angular';

export const FilterFunnelStepsDocument = gql(/* GraphQL*/ `query filterSteps($input: FilterInputGraphql!)
{
  filterSteps(input: $input)
  {
    records{
      name
      id
      object
      {
        id
        name
        type
      }
    }
    total
  }
}

`);
